import { CreditCard } from 'lucide-react'

export default function AdminSubscriptionsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Subskrypcja</h1>
        <p className="text-gray-500">Zarządzaj planem i płatnościami</p>
      </div>

      <div className="card p-8 text-center">
        <CreditCard className="w-12 h-12 mx-auto text-gray-300 mb-4" />
        <p className="text-gray-500">Panel subskrypcji zostanie wkrótce dodany</p>
      </div>
    </div>
  )
}
